import { useParams } from "react-router-dom";
import { FileExplorer } from "@/components/files";

export default function FolderPage() {
  const { folderId } = useParams<{ folderId: string }>();

  return <FileExplorer folderId={folderId || null} />;
}
